import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { APP_STATE } from '../../../constants'
import Loader from '../../shared/Loader'

import ModalWindow from '../ModalWindow'
import TooltipIcon from '../TooltipIcon'
import Text from '../Text'
import { VERMILION, RED, TEXT_SMALL, TEXT_BIG } from '../../../constants'
import RuleSelectionSection from '../FeedAuditorComponents/RuleSelectionSection'

const Grid = styled.div`
  display: grid;
  grid-gap: 18px;
`

const Line = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
`

const ErrorMessage = styled.div`
  position: absolute;
  size: ${TEXT_SMALL};
  color: ${VERMILION};
  bottom: -20px;
  left: 5px;
`

const AuditRuleAmendmentDialog = ({
  onClose,
  onSave,
  visible,
  auditToAmend,
  setRulesToRemove,
  auditModalAmendmentRulesState,
  rulesList,
  auditRuleAmendmentState,
  auditRuleAmendmentResponse,
}) => {
  const { t } = useTranslation()
  const [selectedRuleset, setSelectedRuleset] = useState('')
  const [selectedRulesList, setSelectedRulesList] = useState([])
  const [formErrors, setFormErrors] = useState({})

  useEffect(
    () => {
      setFormErrors({
        noRules: selectedRulesList.length === 0,
      })
    },
    [selectedRulesList]
  )

  useEffect(
    () => {
      // Reset dialog when amendment is successful
      if (auditRuleAmendmentState == APP_STATE.DONE) {
        setStateToInitial()
      }
    },
    [auditRuleAmendmentState]
  )

  const handleClose = () => {
    onClose()
    setStateToInitial()
  }

  const setStateToInitial = () => {
    setSelectedRulesList([])
  }

  const handleSave = () => {
    onSave(selectedRulesList)
  }

  function isFormValid() {
    let formIsValid = true

    if (selectedRulesList.length === 0) {
      formIsValid = false
    }

    return formIsValid
  }

  function isModalDataFetching() {
    //if states are undefined, null, or FETCHING return true
    if (
      !auditModalAmendmentRulesState ||
      auditModalAmendmentRulesState == APP_STATE.FETCHING
    ) {
      return true
    }
    return false
  }

  function isModalDataFailed() {
    if (auditModalAmendmentRulesState == APP_STATE.ERROR) {
      return true
    }
    return false
  }

  function okButtonDisabled() {
    if (!isFormValid() || isModalDataFetching() || isModalDataFailed()) {
      return true
    }
  }

  return (
    <ModalWindow
      minWidth={'40%'}
      setWidth={'50%'}
      okText={t('removeAuditRules')}
      onCancel={handleClose}
      onOk={handleSave}
      title={t('amend_rules_for_audit_title')}
      visible={visible}
      okButtonDisabledState={okButtonDisabled()}
    >
      {isModalDataFetching() ? (
        <Loader />
      ) : isModalDataFailed() ? (
        t('feed_audit_modal_data_failed')
      ) : (
        <Grid>
          <Line>
            <Text size={TEXT_BIG} color={RED} bold>
              {t('audit_rule_removal_warning1')}
            </Text>
            <TooltipIcon
              title={t('audit_rule_removal_warning2')}
              position={'bottom'}
              colour={RED}
            />
            {formErrors.noRules ? (
              <ErrorMessage>
                {t('audit_rule_removal_rules_required')}
              </ErrorMessage>
            ) : null}
          </Line>
          {auditRuleAmendmentState == APP_STATE.ERROR && (
            <Line>
              <Text size={TEXT_BIG} color={RED} bold>
                {auditRuleAmendmentResponse}
              </Text>
            </Line>
          )}
          <span />
          {rulesList.map((group, index) => (
            <RuleSelectionSection
              ruleGroupName={group.name}
              displayReportType={0}
              rulesList={group.rule}
              selectedRulesList={selectedRulesList}
              setSelectedRulesList={setSelectedRulesList}
              resetSelectedRuleset={() => setSelectedRuleset('')}
              key={auditToAmend + '_ruleAmendmentsHolder_' + index}
            />
          ))}
        </Grid>
      )}
    </ModalWindow>
  )
}

export default AuditRuleAmendmentDialog
